import axios from 'axios';
import request, { apiHost } from '../utils/request';

const BASE = '/automation';

export const startRun = async (sectionId) => {
  const { data } = await request.post(`${BASE}/runs`, { sectionId });
  return data;
};

// The server owns the queue: it creates every run up front and dispatches them
// one at a time, so the order survives a reload and applies to every tab.
export const startBatch = async (sectionIds) => {
  const { data } = await request.post(`${BASE}/batches`, { sectionIds });
  return data.runs || [];
};

export const fetchRun = async (runId) => {
  const { data } = await request.get(`${BASE}/runs/${runId}`);
  return data;
};

// Newest run per section, so each row shows its own last result and report.
export const fetchLatestRuns = async () => {
  const { data } = await request.get(`${BASE}/runs/latest`);
  return data.runs || [];
};

// Fetched as a blob so the Authorization header can be sent, which avoids the
// report cookie entirely. The PDF itself is rendered in CI, not on request.
export const downloadReport = async (runId, filename) => {
  const { data } = await axios.get(`${apiHost}${BASE}/runs/${runId}/report.pdf`, {
    headers: { Authorization: `Bearer ${request.getToken()}` },
    responseType: 'blob'
  });

  const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const errorMessageFrom = (err, fallback) => {
  const message = err && err.response && err.response.data && err.response.data.message;
  return message || fallback;
};
